import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function Home() {
  const [vidId, setVidId] = useState();

  fetch(
    `https://www.googleapis.com/youtube/v3/search?key=${process.env.REACT_APP_GOOGLE_KEY}&channelId=UCTkqqJWV5BONv9of3LqjouQ&part=snippet,id&order=date&maxResults=1`
  )
    .then((res) => res.json())
    .then((r) => {
      if (!r) return;
      setVidId(r.items[0].id.videoId);
    });

  const src = `https://www.youtube.com/embed/${vidId}?si=xBxZ17HovfdVoyUh`;

  useEffect(() => {
    const downArrow = document.querySelector("i.downArrow");

    downArrow.addEventListener("click", () => {
      window.scrollTo({
        top: window.innerHeight,
        left: "0",
        behavior: "smooth",
      });
    });
  });

  return (
    <div className="home">
      <div className="logo">
        <img src="/trp-name.png" alt="" />
      </div>
      <div className="buttons">
        <Link to="/">
          <button>Home</button>
        </Link>
        <Link to="/faq">
          <button>FAQ</button>
        </Link>
        <Link to="/applications">
          <button>Applications</button>
        </Link>
      </div>
      <i className="fa-solid fa-circle-chevron-down downArrow"></i>
      <div className="home-bottom">
        <div className="aboutUs">
          <img src="/media/sky.png" alt="" className="sky" />
          <h1>About Us</h1>
          <p>
            Welcome to Tropical Roleplay, the ultimate FiveM server that will
            transport you to a tropical paradise like no other! Immerse yourself
            in a vibrant and dynamic world where you can live out your wildest
            dreams and create your own unique story. Our server offers a wide
            range of custom features and content that will keep you engaged and
            entertained for hours on end. From custom guns and cars to unique
            scripts and activities, there is never a dull moment in Tropical
            Roleplay. Join a gang, start a business, or simply explore the
            stunning landscapes and bustling city streets. With a dedicated and
            friendly community, you'll never feel alone in this virtual
            paradise. Collaborate with other players, form alliances, or engage
            in thrilling shootouts. The possibilities are endless! So, what are
            you waiting for? Dive into the world of Tropical Roleplay and
            experience the excitement and adventure that awaits you. Get ready
            to create memories that will last a lifetime. See you in paradise!
          </p>
        </div>
        <div className="images">
          <div>
            <img src="/media/city.png" alt="" className="city" />
            <p className="city-dsc">Have a nap</p>
          </div>
          <div>
            <img src="/media/gangs.png" alt="" className="gangs" />
            <p className="gangs-dsc">Meet new people</p>
          </div>
          <div>
            <img src="/media/lambo.png" alt="" className="lambo" />
            <p className="lambo-dsc">Advanced mechanics</p>
          </div>
          <div>
            <img src="/media/mercedes.png" alt="" className="merc" />
            <p className="merc-dsc">Custom cars</p>
          </div>
          <div>
            <img src="/media/robbing.png" alt="" className="robbing" />
            <p className="robbing-dsc">Make some food to share</p>
          </div>
        </div>
        <a
          href="https://www.trackyserver.com/fivem-server/country/US"
          className="serverlist"
        >
          <img
            alt="FiveM servers list"
            src="https://www.trackyserver.com/pages/images/logo4.png"
          />
        </a>
        <div className="video">
          <h1>Our Latest YouTube Video</h1>
          <iframe
            width="560"
            height="315"
            src={src}
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>
  );
}
